import { createRouter, createWebHistory } from 'vue-router'
import { session } from './session'

// Locally Labs is served under /labs/; on labs.hexapla.org at the root.
const base = process.env.LAB_BASE || '/labs/'

const router = createRouter({
  history: createWebHistory(base),
  routes: [
    { path: '/login', component: () => import('./views/LabLogin.vue') },
    { path: '/', component: () => import('./views/LabHome.vue') },
    { path: '/lemma/:id', component: () => import('./views/LabLemmaPage.vue') },
    { path: '/search', component: () => import('./views/LabSearch.vue') },
    { path: '/relations', component: () => import('./views/LabRelations.vue') },
    { path: '/credits', component: () => import('./views/LabCredits.vue') },
    { path: '/:catchAll(.*)', redirect: '/' },
  ],
})

// Everything but the sign-in page needs a session; signed in, the sign-in
// page leads home.
router.beforeEach((to) => {
  const signedIn = Boolean(session.token)
  if (to.path === '/login') return signedIn ? '/' : true
  return signedIn ? true : '/login'
})

export default router
